// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__xGLWY","tab":"Tabs_tab__G85R8","active":"Tabs_active__WM1cd"};